export type FieldWarnings = {
  [key: string]: { message: string } | undefined
}

export const warningCheck = (condition: boolean, message: string) => {
  return condition ? { message } : undefined
}
